import * as React from "react";
import TableHeader from "./TableHeader";
import StudentRow from "./StudentRow";

const LearningResultsTable = ({ classStageStudentList, activeFilter }) => {
    // activeFilter에 해당하는 학생 필터링
    const filteredStudents = classStageStudentList.filter((student) =>
        student.resultTags.includes(activeFilter) // resultTags에 activeFilter가 포함된 경우만 필터링
    );
    return (
        <div className="flex flex-col justify-center px-7 py-8 mb-32 mt-8 w-full bg-white rounded-3xl border border-solid border-zinc-300 shadow-[0px_2px_7px_rgba(0,0,0,0.1)] max-md:px-5 max-md:max-w-full">
            <table className="flex flex-col w-full rounded-none max-md:max-w-full table-auto">
                <TableHeader />
                {filteredStudents.length > 0 ? (
                    filteredStudents.map((student, index) => (
                        <StudentRow key={index} index={index+1} {...student} />
                    ))
                ) : (
                    <tbody>
                        <tr className="text-center text-gray-500 py-5"><td>데이터가 없습니다.</td></tr>
                    </tbody>
                )}
            </table>
        </div>
    );
};

export default LearningResultsTable;